import type { ReactNode } from 'react';

/**
 * The white card a page's content sits in. `title` adds the section heading
 * most panels open with; leave it out when the heading shares a row with
 * something else and the panel's content renders it.
 */
export function Panel({
  title,
  tone,
  as: Tag = 'section',
  className,
  children,
}: {
  title?: string;
  /** Sage-tinted, for the panel the page is currently acting on. */
  tone?: 'highlight';
  as?: 'section' | 'div';
  className?: string;
  children: ReactNode;
}) {
  const classes = ['card-panel'];
  if (tone === 'highlight') classes.push('card-panel-highlight');
  if (className) classes.push(className);
  return (
    <Tag className={classes.join(' ')}>
      {title && <h2 className="heading-section">{title}</h2>}
      {children}
    </Tag>
  );
}
